import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Textarea } from '../../../components/ui/textarea';
import { Save, Eye } from 'lucide-react';
import ImageUploadField from '../../common/ImageUploadField';

export default function CMSHeroSection({
  heroForm,
  setHeroForm,
  isSaving,
  onSave
}) {
  return (
    <div className="bg-white rounded-2xl p-6 shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="font-bold text-slate-900 font-[Poppins]">Hero Section</h3>
          <p className="text-sm text-slate-500">The main banner at the top of your landing page</p>
        </div>
        <a 
          href="/" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-sm text-amber-600 hover:text-amber-700 flex items-center gap-1"
        >
          <Eye className="w-4 h-4" />
          Preview
        </a>
      </div>

      <div className="space-y-4">
        <div>
          <Label>Main Title</Label>
          <Input
            value={heroForm.title}
            onChange={(e) => setHeroForm(prev => ({ ...prev, title: e.target.value }))}
            className="h-12 mt-1.5"
            placeholder="Your Home's Hero is Just a Tap Away"
            data-testid="hero-title"
          />
          <p className="text-xs text-slate-400 mt-1">
            Use &quot;Hero&quot; or &quot;Bayani&quot; to highlight with accent color
          </p>
        </div>

        <div>
          <Label>Subtitle</Label>
          <Textarea
            value={heroForm.subtitle}
            onChange={(e) => setHeroForm(prev => ({ ...prev, subtitle: e.target.value }))}
            className="mt-1.5"
            rows={3}
            placeholder="Connect with verified service providers..."
            data-testid="hero-subtitle"
          />
        </div>

        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <Label>CTA Button Text</Label>
            <Input
              value={heroForm.cta_text}
              onChange={(e) => setHeroForm(prev => ({ ...prev, cta_text: e.target.value }))}
              className="h-12 mt-1.5"
              placeholder="Book a Hero"
              data-testid="hero-cta-text"
            />
          </div>
          <div>
            <Label>CTA Button Link</Label>
            <Input
              value={heroForm.cta_link}
              onChange={(e) => setHeroForm(prev => ({ ...prev, cta_link: e.target.value }))}
              className="h-12 mt-1.5"
              placeholder="/register"
              data-testid="hero-cta-link"
            />
          </div>
        </div>

        <div>
          <Label>Background Image (optional)</Label>
          <div className="mt-1.5">
            <ImageUploadField
              value={heroForm.background_image}
              onChange={(val) => setHeroForm(prev => ({ ...prev, background_image: val }))}
              placeholder="https://... or upload"
              testId="hero-bg-image"
            />
          </div>
        </div>

        <Button 
          onClick={onSave}
          disabled={isSaving}
          className="bg-amber-500 hover:bg-amber-600 text-slate-900"
          data-testid="save-hero-btn"
        >
          <Save className="w-4 h-4 mr-2" />
          {isSaving ? 'Saving...' : 'Save Hero Section'}
        </Button>
      </div>
    </div>
  );
}
